// @ts-nocheck
let uabModule = ''
let webUmidToken = ''

const AWSC = window.AWSC

AWSC.use('uab', (state, uab) => {
  if (state === 'loaded') {
    console.log('AWSC:uab ready');
    uabModule = uab;
  }
})

AWSC.use('um', (state, um) => {
  if(state === 'loaded') {
    um.init({
      appName: 'saf-aliyun-com',
    }, (initState, result) => {
        if(initState === 'success') {
          console.log('AWSC:webUmidToken ready');
          webUmidToken = result.tn;
        }
      });
  }
});

export default function () {
  return {
    uaToken: uabModule && uabModule.getUA(),
    webUmidToken: webUmidToken
  }
}
